export const onValidPasswordMessage = (
  item: any,
  password: passwordDataType,
) => {
  let message = "";
  let regExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;

  if (!item.value) {
    message = `Please ${item?.placeholder || ""}`;
  } else if (item.name !== "oldPassword" && !regExp.test(item.value)) {
    message = `Password must contain one digit from 1 to 9, one lowercase letter, one uppercase letter, one special character, no space, and it must be 8-16 characters long.`;
  } else if (
    item.name === "confirmPassword" &&
    password.newPassword !== item.value
  ) {
    message = `Password is not matched`;
  }
  return message;
};

export const checkIsPasswordValid = (item: any, password: passwordDataType) => {
  let isValid = true;
  let regExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;

  if (!item.value) {
    isValid = false;
  } else if (item.name !== "oldPassword" && !regExp.test(item.value)) {
    isValid = false;
  } else if (
    item.name === "confirmPassword" &&
    password.newPassword !== item.value
  ) {
    isValid = false;
  }
  return isValid;
};
